/* =========================================================
   GERACAO DA EXECUCAO
   A troca de camuflagem substitui o HTML da secao e reinjeta este
   arquivo. Sem controle, a execucao ANTIGA continuaria com seus
   listeners de window/scroll apontando pra elementos ja removidos —
   e, pior, brigando com a nova pelo classList do body (a barra fixa
   ligando e desligando sozinha).
   Cada execucao guarda seu numero; quem nao for a atual se aposenta.
   ========================================================= */
window.__fmPdpGen = (window.__fmPdpGen || 0) + 1;
window.__fmPdpSrc = (document.currentScript && document.currentScript.src) || window.__fmPdpSrc || "";

(function () {
  const root = document.querySelector("[data-fm-v2-pdp]");
  if (!root) return;

  const form = root.querySelector("#fm-v2-product-form");
  const variantInput = root.querySelector("#fm-v2-variant-id");
  const qtyInput = root.querySelector("#fm-v2-qty-input");
  const thumbs = root.querySelectorAll("[data-fm-thumb]");
  const rows = root.querySelectorAll("[data-fm-variant-row]");
  const diameterSelect = root.querySelector("[data-fm-diameter]");
  const btnMinus = root.querySelector("[data-fm-qty-minus]");
  const btnPlus = root.querySelector("[data-fm-qty-plus]");
  const btnBuyNow = root.querySelector("[data-fm-buy-now]");
  const submitBtns = root.querySelectorAll(".fm-v2-btn--primary, .fm-v2-btn--secondary");
  const fallbackId = root.getAttribute("data-fm-fallback-id") || ""; // variante padrão p/ "prosseguir mesmo assim"

  /* ---- Galeria: trilho com arrastar nativo (02/10) --------------------
   *
   * O QUE ESTAVA ERRADO. A foto grande era uma <img> unica trocada por JS.
   * Arrastar nao fazia nada — so miniatura e seta. E a galeria girava
   * sozinha a cada 5s, com a pausa presa em mouseenter/mouseleave: eventos
   * que NAO EXISTEM em tela de toque. No celular ela nunca parava. O
   * cliente tocava a seta, via a foto certa, e 5s depois ela pulava de
   * novo. Nas gravacoes isso aparece como gente clicando sem parar.
   *
   * O QUE MUDOU. Trilho com scroll-snap: o arrastar e do navegador. E o
   * autoplay saiu inteiro — quem manda na galeria e o cliente.
   *
   * A posicao nunca e guardada numa variavel minha: ela e SEMPRE lida do
   * scrollLeft do trilho. Guardar um indice paralelo seria a mesma classe
   * de bug de antes — a tela diz uma coisa, a variavel diz outra.
   */
  var gallery = root.querySelector("[data-fm-gallery]");
  var track = root.querySelector("[data-fm-gallery-track]");
  var dotsBox = root.querySelector("[data-fm-gallery-dots]");
  var galleryPrev = root.querySelector("[data-fm-gallery-prev]");
  var galleryNext = root.querySelector("[data-fm-gallery-next]");

  function visiveis(lista) {
    return Array.prototype.filter.call(lista, function (el) { return !el.hidden; });
  }
  function slidesVis() { return visiveis(root.querySelectorAll("[data-fm-slide]")); }
  function thumbsVis() { return visiveis(thumbs); }

  /* lida do trilho, nunca de um contador paralelo */
  function indiceAtual() {
    var vis = slidesVis();
    if (!track || !vis.length) return 0;
    var meio = track.scrollLeft + track.clientWidth / 2;
    var melhor = 0, menor = Infinity;
    vis.forEach(function (s, i) {
      var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - meio);
      if (d < menor) { menor = d; melhor = i; }
    });
    return melhor;
  }

  function irPara(i, suave) {
    var vis = slidesVis();
    if (!track || !vis.length) return;
    if (i < 0) i = vis.length - 1;
    if (i >= vis.length) i = 0;
    try {
      track.scrollTo({ left: vis[i].offsetLeft, behavior: suave === false ? "auto" : "smooth" });
    } catch (e) {
      track.scrollLeft = vis[i].offsetLeft;   /* navegador velho */
    }
  }

  function montarBolas() {
    if (!dotsBox) return;
    var n = slidesVis().length;
    dotsBox.innerHTML = "";
    if (n < 2) return;
    for (var i = 0; i < n; i++) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "fm-v2-gallery__dot";
      b.setAttribute("data-fm-dot", String(i));
      b.setAttribute("aria-label", "Ver imagem " + (i + 1));
      dotsBox.appendChild(b);
    }
  }

  /* Centraliza a miniatura ativa mexendo SO no scrollLeft da fita.
   *
   * Era scrollIntoView, e isso quebrava a seta: o scrollTo suave do trilho
   * comecava, o scroll disparava sincronizar(), o scrollIntoView iniciava
   * OUTRA rolagem suave e o navegador cancelava a primeira no meio. A foto
   * parava a 53px em vez de andar os 356 — ou seja, a seta "nao funcionava",
   * exatamente o sintoma que o cliente relatou, agora por outra causa.
   * Atribuicao direta nao anima e nao disputa com ninguem.
   */
  function manterAVista(t) {
    var fita = t.parentNode;
    if (!fita || fita.scrollWidth <= fita.clientWidth) return;
    var alvo = t.offsetLeft - (fita.clientWidth - t.offsetWidth) / 2;
    var max = fita.scrollWidth - fita.clientWidth;
    fita.scrollLeft = Math.max(0, Math.min(alvo, max));
  }

  function sincronizar() {
    var i = indiceAtual();
    var tv = thumbsVis();
    Array.prototype.forEach.call(thumbs, function (t) { t.classList.remove("is-active"); });
    if (tv[i]) {
      tv[i].classList.add("is-active");
      manterAVista(tv[i]);
    }
    if (dotsBox) {
      var bolas = dotsBox.children;
      for (var k = 0; k < bolas.length; k++) {
        bolas[k].classList.toggle("is-active", k === i);
      }
    }
  }

  if (track) {
    var aguardando = false;
    track.addEventListener("scroll", function () {
      if (aguardando) return;
      aguardando = true;
      requestAnimationFrame(function () { aguardando = false; sincronizar(); });
    }, { passive: true });

    if (galleryPrev) galleryPrev.addEventListener("click", function () { irPara(indiceAtual() - 1); });
    if (galleryNext) galleryNext.addEventListener("click", function () { irPara(indiceAtual() + 1); });

    Array.prototype.forEach.call(thumbs, function (t) {
      t.addEventListener("click", function () {
        var i = thumbsVis().indexOf(t);
        if (i >= 0) irPara(i);
      });
    });

    if (dotsBox) {
      dotsBox.addEventListener("click", function (e) {
        var d = e.target && e.target.closest ? e.target.closest("[data-fm-dot]") : null;
        if (d) irPara(parseInt(d.getAttribute("data-fm-dot"), 10) || 0);
      });
    }

    /* o filtro de camuflagem mora em outro escopo e precisa remontar isto */
    root.fmGaleria = { montarBolas: montarBolas, irPara: irPara, sincronizar: sincronizar };

    montarBolas();
    sincronizar();
  }

/* Metragem padrao. Era fixo em 1200 — trocado em 26/09 a pedido do Jorge.
     O valor vem do editor (data-fm-metragem-padrao), com 300 como padrao.
     Se a metragem pedida nao existir naquela bitola, cai na primeira
     disponivel em vez de nao marcar nada. */
  function preselectMetragemPadrao() {
    var visibleRows = Array.prototype.filter.call(rows, function (r) {
      return !r.hidden && r.getAttribute("data-available") === "true";
    });
    if (!visibleRows.length) return;

    var alvo = (root.getAttribute("data-fm-metragem-padrao") || "300").replace(/\s+/g, "");
    var target = null;
    if (alvo) {
      target = visibleRows.filter(function (r) {
        var meters = r.getAttribute("data-option2") || r.getAttribute("data-option1") || "";
        return meters.replace(/\s+/g, "").indexOf(alvo) !== -1;
      })[0];
    }
    if (!target) target = visibleRows[0];
    if (target) selectRow(target);
  }



  function setButtonsAvailable(on) {
    // Botão de compra sempre clicável; o aviso de bitola cuida da validação.
    submitBtns.forEach(function (b) {
      b.disabled = false;
    });
  }

  function selectRow(row) {
    rows.forEach(function (r) {
      r.classList.toggle("is-selected", r === row);
      r.setAttribute("aria-selected", r === row ? "true" : "false");
    });
    if (!row) return;
    var id = row.getAttribute("data-variant-id");
    if (id && variantInput) variantInput.value = id;
    setButtonsAvailable(row.getAttribute("data-available") === "true");
  }

  function firstDiameterValue() {
    var fallback = "";
    for (var i = 0; i < rows.length; i++) {
      var o = rows[i].getAttribute("data-option1");
      if (!o || !linhaDaCamu(rows[i])) continue;
      if (!fallback) fallback = o;
      if (rows[i].getAttribute("data-available") === "true") return o;
    }
    return fallback;
  }

  /* ---- Pre-selecao automatica (26/09) ----
     Substitui o modal "voce nao selecionou o diametro". Quando o cliente
     manda comprar sem escolher, a gente escolhe por ele:
       1. bitola pela cascata do editor (ex.: 0.28mm -> 0.32mm -> 0.24mm),
          pulando as que estao esgotadas;
       2. se nenhuma da cascata servir, a primeira bitola disponivel;
       3. metragem padrao (300m).
     A bitola e aplicada pelo <select> + evento "change": e esse change que
     filtra as metragens E que faz as caixas de bitola se marcarem. Setar o
     valor sem disparar o evento deixaria a tela mentindo sobre o que foi
     escolhido. */
  function bitolaTemEstoque(valor) {
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute("data-option1") === valor &&
          linhaDaCamu(rows[i]) &&
          rows[i].getAttribute("data-available") === "true") return true;
    }
    return false;
  }

  function escolherBitola() {
    if (!diameterSelect) return "";
    var pref = (root.getAttribute("data-fm-bitolas-preferidas") || "").split("|");
    for (var i = 0; i < pref.length; i++) {
      var frag = pref[i].replace(/^\s+|\s+$/g, "");
      if (!frag) continue;
      for (var j = 0; j < diameterSelect.options.length; j++) {
        var v = diameterSelect.options[j].value;
        // o valor real e "0.28mm (40lbs)"; casamos pelo fragmento "0.28mm"
        if (v && v.indexOf(frag) !== -1 && bitolaTemEstoque(v)) return v;
      }
    }
    return firstDiameterValue() || "";
  }

  /* Publicados no root para a troca de camuflagem reaproveitar a MESMA regra
     de escolha. Sem isso eu teria que repetir a cascata em dois lugares — e
     duas copias da mesma regra e como a gente perdeu o brinde do kit. */
  root.fmBitolaTemEstoque = bitolaTemEstoque;
  root.fmEscolherBitola = escolherBitola;

  /* Devolve o id da variante a comprar, escolhendo o que faltar. 0 = nao deu. */
  function garantirSelecao() {
    if (needsBitola()) {
      var b = escolherBitola();
      if (b) {
        diameterSelect.value = b;
        updatePlaceholderStyle();
        diameterSelect.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
    if (variantInput && !variantInput.value) preselectMetragemPadrao();
    var id = parseInt(String(variantInput ? variantInput.value : ""), 10);
    if (!id) id = parseInt(String(fallbackId), 10) || 0;
    return id;
  }

  function metersOf(row) {
    if (!row) return "";
    return (row.getAttribute("data-option2") || row.getAttribute("data-option1") || "").trim();
  }

  /* V3: a metragem agora vem ANTES da bitola, então preservamos a metragem
     que o cliente já escolheu quando ele troca de bitola. */
  function reselectMeters(meters) {
    if (!meters) return false;
    var match = Array.prototype.filter.call(rows, function (r) {
      return !r.hidden && r.getAttribute("data-available") === "true" && metersOf(r) === meters;
    })[0];
    if (match) { selectRow(match); return true; }
    return false;
  }

  /* CAMUFLAGEM COMO VARIANTE (opcao 3).
     Quando o produto tem a 3a opcao, cada par bitola+metragem existe DUAS
     vezes — uma por camuflagem. Sem filtrar por ela, a grade de metragem
     apareceria duplicada e o clique pegaria a variante errada. */
  var camuBotoes = root.querySelectorAll("[data-fm-camu-var]");
  var camuAtual = camuBotoes.length ? camuBotoes[0].getAttribute("data-value") : "";

  function linhaDaCamu(row) {
    var o3 = row.getAttribute("data-option3");
    return !o3 || !camuAtual || o3 === camuAtual;
  }

  function applyDiameterFilter(diameter) {
    var hasDia = !!diameter; // "" = placeholder (bitola não escolhida)
    // Sem bitola: mostra as metragens do 1º diâmetro como preview (não esconde nada, nada selecionado).
    var showDia = hasDia ? diameter : firstDiameterValue();

    var prevRow = Array.prototype.filter.call(rows, function (r) {
      return r.classList.contains("is-selected");
    })[0];
    var prevMeters = metersOf(prevRow);

    rows.forEach(function (row) {
      var opt1 = row.getAttribute("data-option1");
      row.hidden = opt1 !== showDia || !linhaDaCamu(row);
    });
    /* limpa qualquer seleção anterior — usuário precisa escolher a metragem */
    rows.forEach(function (r) {
      r.classList.remove("is-selected");
      r.setAttribute("aria-selected", "false");
    });
    if (variantInput) variantInput.value = "";
    setButtonsAvailable(false);
    if (hasDia) {
      // mantém a metragem escolhida; se ela não existir/estiver esgotada nessa bitola, cai no padrão
      if (!reselectMeters(prevMeters)) preselectMetragemPadrao();
    }
  }

  function updatePlaceholderStyle() {
    // centraliza o texto do select só enquanto o placeholder está ativo (valores reais ficam à esquerda)
    if (diameterSelect) diameterSelect.classList.toggle("fm-v2-select--placeholder", !diameterSelect.value);
  }

  if (diameterSelect) {
    updatePlaceholderStyle();
    diameterSelect.addEventListener("change", function () {
      updatePlaceholderStyle();
      applyDiameterFilter(diameterSelect.value);
    });
    applyDiameterFilter(diameterSelect.value);
  }

  rows.forEach(function (row) {
    row.addEventListener("click", function () {
      if (row.hidden || row.disabled) return;
      selectRow(row);
    });
  });

  /* troca de camuflagem: mantem bitola e metragem, so muda a variante */
  Array.prototype.forEach.call(camuBotoes, function (btn) {
    btn.addEventListener("click", function () {
      var alvo = btn.getAttribute("data-value");
      if (!alvo || alvo === camuAtual) return;

      var marcada = Array.prototype.filter.call(rows, function (r) {
        return r.classList.contains("is-selected");
      })[0];
      var metrosAntes = metersOf(marcada);

      camuAtual = alvo;
      Array.prototype.forEach.call(camuBotoes, function (o) {
        var on = o === btn;
        o.classList.toggle("is-selected", on);
        o.setAttribute("aria-selected", on ? "true" : "false");
      });

      applyDiameterFilter(diameterSelect ? diameterSelect.value : "");
      if (metrosAntes) reselectMeters(metrosAntes);
    });
  });

  function clampQty(n) {
    n = parseInt(String(n), 10);
    if (isNaN(n) || n < 1) n = 1;
    return n;
  }

  if (btnMinus && qtyInput) {
    btnMinus.addEventListener("click", function () {
      qtyInput.value = clampQty(Number(qtyInput.value) - 1);
    });
  }
  if (btnPlus && qtyInput) {
    btnPlus.addEventListener("click", function () {
      qtyInput.value = clampQty(Number(qtyInput.value) + 1);
    });
  }

  /* ---- Smooth exclusive accordion ---- */
  function accordionOpen(detail) {
    var body = detail.querySelector(".fm-v2-details__body");
    if (!body) { detail.open = true; return; }
    detail.open = true;
    var targetH = body.scrollHeight;
    body.style.overflow = "hidden";
    body.style.height = "0px";
    body.style.marginTop = "0px";
    body.style.opacity = "0";
    body.getBoundingClientRect();
    body.style.transition = "height .32s ease, margin-top .32s ease, opacity .24s ease";
    body.style.height = targetH + "px";
    body.style.marginTop = "6px";
    body.style.opacity = "1";
    body.addEventListener("transitionend", function fn(e) {
      if (e.propertyName !== "height") return;
      body.removeEventListener("transitionend", fn);
      body.style.cssText = "";
    });
  }

  function accordionClose(detail) {
    var body = detail.querySelector(".fm-v2-details__body");
    if (!body) { detail.open = false; return; }
    var currentH = body.getBoundingClientRect().height;
    body.style.overflow = "hidden";
    body.style.height = currentH + "px";
    body.style.marginTop = "6px";
    body.style.opacity = "1";
    body.getBoundingClientRect();
    body.style.transition = "height .32s ease, margin-top .32s ease, opacity .24s ease";
    body.style.height = "0px";
    body.style.marginTop = "0px";
    body.style.opacity = "0";
    body.addEventListener("transitionend", function fn(e) {
      if (e.propertyName !== "height") return;
      body.removeEventListener("transitionend", fn);
      detail.open = false;
      body.style.cssText = "";
    });
  }

  root.querySelectorAll(".fm-v2-details-group").forEach(function (group) {
    var items = Array.from(group.querySelectorAll(":scope > details.fm-v2-details"));
    items.forEach(function (detail) {
      var summary = detail.querySelector("summary");
      if (!summary) return;
      summary.addEventListener("click", function (e) {
        e.preventDefault();
        var wasOpen = detail.open;
        items.forEach(function (d) { if (d.open) accordionClose(d); });
        if (!wasOpen) accordionOpen(detail);
      });
    });
  });

  /* ---- Video thumb sound toggle ---- */
  var svgMuted = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
  var svgUnmuted = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/></svg>';

  root.querySelectorAll(".fm-v2-video-thumb").forEach(function (thumb) {
    var video = thumb.querySelector("video");
    if (!video) return;

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "fm-v2-video-thumb__sound";
    btn.setAttribute("aria-label", "Ativar som");
    btn.innerHTML = svgMuted;
    thumb.appendChild(btn);

    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      var unmuting = video.muted;
      /* mute todos os outros vídeos primeiro */
      root.querySelectorAll(".fm-v2-video-thumb video").forEach(function (v) { v.muted = true; });
      root.querySelectorAll(".fm-v2-video-thumb__sound").forEach(function (b) {
        b.innerHTML = svgMuted;
        b.classList.remove("is-unmuted");
        b.setAttribute("aria-label", "Ativar som");
      });
      if (unmuting) {
        video.currentTime = 0;
        video.muted = false;
        btn.innerHTML = svgUnmuted;
        btn.classList.add("is-unmuted");
        btn.setAttribute("aria-label", "Silenciar");
      }
    });
  });

  /* ---- YouTube video hero ---- */
  function parseYouTubeId(url) {
    if (!url) return null;
    var m = url.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    return m ? m[1] : null;
  }

  root.querySelectorAll("[data-fm-video-hero]").forEach(function (hero) {
    var btn = hero.querySelector(".fm-v2-play");
    if (!btn) return;
    btn.addEventListener("click", function () {
      var id = parseYouTubeId(hero.getAttribute("data-fm-video-hero"));
      if (!id) return;
      var iframe = document.createElement("iframe");
      iframe.src = "https://www.youtube.com/embed/" + id + "?autoplay=1&rel=0&modestbranding=1&iv_load_policy=3&playsinline=1&color=white";
      iframe.allow = "autoplay; fullscreen; picture-in-picture";
      iframe.allowFullscreen = true;
      iframe.style.cssText = "position:absolute;inset:0;width:100%;height:100%;border:0;";
      var img = hero.querySelector("img");
      if (img) img.hidden = true;
      btn.hidden = true;
      hero.appendChild(iframe);
    });
  });

  /* ---- Generic carousel (data-fm-carousel="N") ---- */
  root.querySelectorAll("[data-fm-carousel]").forEach(function (carousel) {
    var track   = carousel.querySelector("[data-fm-carousel-track]");
    var prevBtn = carousel.querySelector("[data-fm-carousel-prev]");
    var nextBtn = carousel.querySelector("[data-fm-carousel-next]");
    if (!track || !prevBtn || !nextBtn) return;
    var items = Array.from(track.children);
    if (!items.length) return;
    var current = 0;
    var desktopPer = parseInt(carousel.getAttribute("data-fm-carousel"), 10) || 3;

    function perPage() { return window.innerWidth >= 990 ? desktopPer : 1; }
    function maxIdx()  { return Math.max(0, items.length - perPage()); }

    function stride() {
      if (items.length > 1) {
        return items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
      }
      return items[0].getBoundingClientRect().width;
    }

    function goTo(n) {
      current = Math.max(0, Math.min(n, maxIdx()));
      track.style.transform = "translateX(" + (-current * stride()) + "px)";
      var max = maxIdx();
      prevBtn.hidden = nextBtn.hidden = max === 0;
      prevBtn.disabled = current === 0;
      nextBtn.disabled = current >= max;
    }

    prevBtn.addEventListener("click", function () { goTo(current - 1); });
    nextBtn.addEventListener("click", function () { goTo(current + 1); });

    var rTimer;
    window.addEventListener("resize", function () {
      clearTimeout(rTimer);
      rTimer = setTimeout(function () { goTo(Math.min(current, maxIdx())); }, 100);
    });

    goTo(0);
  });

  /* ---- Tenta abrir o mini cart do tema ---- */
  function openMiniCart() {
    var drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.open === "function") { drawer.open(); return true; }
    var notification = document.querySelector("cart-notification");
    if (notification && typeof notification.open === "function") { notification.open(); return true; }
    var trigger = document.querySelector(
      "[data-cart-drawer-toggle], [aria-controls='cart-drawer'], .js-drawer-open-cart, " +
      ".cart-link, .header__icon--cart, .site-header__cart, [href='#cart-drawer']"
    );
    if (trigger) { trigger.click(); return true; }
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:added", { bubbles: true }));
    return false;
  }

  /* ---- Injeta HTML de seções devolvidas pelo Section Rendering API ---- */
  function injectSection(sectionId, html) {
    if (!html) return false;
    var wrapper = document.getElementById("shopify-section-" + sectionId);
    if (wrapper) {
      var p1 = new DOMParser().parseFromString(html, "text/html");
      var newWrap = p1.getElementById("shopify-section-" + sectionId);
      wrapper.innerHTML = newWrap ? newWrap.innerHTML : html;
      return true;
    }
    var selectors = [sectionId, "#" + sectionId, "[data-section-id='" + sectionId + "']"];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        var p2 = new DOMParser().parseFromString(html, "text/html");
        var fresh = p2.querySelector(selectors[i]);
        el.innerHTML = fresh ? fresh.innerHTML : html;
        return true;
      }
    }
    return false;
  }

  /* ---- Abre o drawer se sessionStorage indicou (pós-reload) ---- */
  try {
    if (sessionStorage.getItem("fm_open_cart") === "1") {
      sessionStorage.removeItem("fm_open_cart");
      setTimeout(openMiniCart, 250);
    }
  } catch (e) {}

  /* ---- Aviso: bitola (diâmetro) não selecionada ---- */
  function needsBitola() {
    return !!diameterSelect && !diameterSelect.value;
  }

  /* O modal de aviso de bitola foi removido em 26/09: agora a pre-selecao
     automatica resolve (ver garantirSelecao). */

  /* ---- Adicionar ao carrinho: abre mini cart ---- */
  function doAdd(id) {
    var q = clampQty(qtyInput.value);
    var submitBtn = form.querySelector("button[type='submit']");
    if (submitBtn) submitBtn.disabled = true;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [{ id: id, quantity: q }],
        sections: "cart-drawer,cart-icon-bubble,cart-notification",
        sections_url: window.location.pathname
      }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("cart");
        return res.json();
      })
      .then(function (data) {
        if (submitBtn) submitBtn.disabled = false;
        var refreshed = false;
        if (data && data.sections) {
          Object.keys(data.sections).forEach(function (id) {
            if (injectSection(id, data.sections[id])) refreshed = true;
          });
        }
        if (refreshed) {
          openMiniCart();
        } else {
          /* Section Rendering API não funcionou pra esse tema → recarrega a página */
          try { sessionStorage.setItem("fm_open_cart", "1"); } catch (e) {}
          window.location.reload();
        }
      })
      .catch(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  if (form && variantInput && qtyInput) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var id = garantirSelecao();
      if (!id) return;
      doAdd(id);
    });
  }

  /* ---- Finalizar compra: vai direto para checkout ---- */
  function doBuyNow(id) {
    var q = clampQty(qtyInput.value);
    btnBuyNow.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: q }] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("cart");
        window.location.href = "/checkout";
      })
      .catch(function () {
        btnBuyNow.disabled = false;
      });
  }

  if (btnBuyNow && variantInput && qtyInput) {
    btnBuyNow.addEventListener("click", function (e) {
      e.preventDefault();
      var id = garantirSelecao();
      if (!id) return;
      doBuyNow(id);
    });
  }
})();

/* =========================================================
   V3 — caixas de bitola pilotando o <select> escondido.
   Não altera a lógica da V2: só traduz clique-na-caixa em
   change do select, que é quem filtra as metragens.
   ========================================================= */
(function () {
  var root = document.querySelector("[data-fm-v2-pdp]");
  if (!root) return;

  var sel = root.querySelector("[data-fm-diameter]");
  var boxes = root.querySelectorAll("[data-fm-v3-bitola]");
  if (!sel || !boxes.length) return;

  function markSelected(box) {
    Array.prototype.forEach.call(boxes, function (o) {
      var on = o === box;
      o.classList.toggle("is-selected", on);
      o.setAttribute("aria-selected", on ? "true" : "false");
    });
  }

  Array.prototype.forEach.call(boxes, function (box) {
    box.addEventListener("click", function () {
      if (box.disabled) return;
      sel.value = box.getAttribute("data-value");
      sel.dispatchEvent(new Event("change", { bubbles: true }));
      markSelected(box);
    });
  });

  /* se algo mudar o select por fora, as caixas acompanham */
  sel.addEventListener("change", function () {
    var match = null;
    Array.prototype.forEach.call(boxes, function (o) {
      if (o.getAttribute("data-value") === sel.value) match = o;
    });
    markSelected(match);
  });
})();

/* =========================================================
   BARRA FIXA DE COMPRA (26/09)
   Aparece quando os botoes reais saem da tela e some quando
   eles voltam. O botao da barra CLICA no botao real — nao
   duplica a logica de compra. Assim a pre-selecao automatica,
   a quantidade e a abertura do carrinho continuam num lugar so.
   ========================================================= */
(function () {
  var root = document.querySelector("[data-fm-v2-pdp]");
  if (!root) return;

  var barra = root.querySelector("[data-fm-sticky-atc]");
  var acoes = root.querySelector(".fm-v2-actions");
  var real = root.querySelector(".fm-v2-btn--primary");
  if (!barra || !acoes || !real) return;

  var btn = barra.querySelector("[data-fm-sticky-add]");
  var precoEl = barra.querySelector("[data-fm-sticky-price]");

  function mostrar(on) {
    barra.classList.toggle("is-on", on);
    document.body.classList.toggle("fm-sticky-on", on);
  }

  var wasEl = barra.querySelector("[data-fm-sticky-was]");
  var saveEl = barra.querySelector("[data-fm-sticky-save]");
  var selMet = barra.querySelector("[data-fm-sticky-met]");
  var selBit = barra.querySelector("[data-fm-sticky-bitola]");
  var selPrincipal = root.querySelector("[data-fm-diameter]");

  function soNumero(txt) {
    // "R$ 127,00" -> 127.00  (pt-BR: ponto e milhar, virgula e decimal)
    var n = String(txt || "").replace(/[^\d,.-]/g, "").replace(/\./g, "").replace(",", ".");
    return parseFloat(n) || 0;
  }

  /* Preco: le a caixa de metragem marcada. Enquanto nada estiver
     escolhido mostra o menor preco marcado como "a partir de", em vez
     de anunciar um valor que nao e o que vai pro carrinho. */
  function atualizarPreco() {
    if (!precoEl) return;
    var sel = root.querySelector("[data-fm-variant-row].is-selected");
    var p = sel ? sel.querySelector(".fm-v3-box__price") : null;
    var w = sel ? sel.querySelector(".fm-v3-box__was") : null;

    if (wasEl) wasEl.textContent = "";
    if (saveEl) saveEl.textContent = "";

    if (!p) {
      var min = barra.getAttribute("data-fm-preco-min") || "";
      precoEl.textContent = min ? "A partir de " + min : "";
      return;
    }

    precoEl.textContent = p.textContent.trim();
    if (w && wasEl) {
      wasEl.textContent = w.textContent.trim();
      var de = soNumero(w.textContent), por = soNumero(p.textContent);
      if (saveEl && de > por && de > 0) {
        /* Math.floor, nao round: o Liquid calcula o desconto com divisao
           inteira (trunca). Arredondando aqui, a mesma tela mostraria 46%
           no resumo e 45% na caixa do produto. */
        saveEl.textContent = "-" + Math.floor((de - por) / de * 100) + "%";
      }
    }
  }

  /* ---- Os dois seletores da barra ----
     Eles NAO decidem nada: escrevem no painel de cima e deixam a logica
     existente reagir. O de bitola escreve no <select> escondido e dispara
     "change"; o de metragem clica na caixa correspondente. Assim a barra
     e o painel nunca discordam sobre o que esta selecionado. */
  function metragemDe(row) {
    return (row.getAttribute("data-option2") || row.getAttribute("data-option1") || "").trim();
  }

  function preencherMetragens() {
    if (!selMet) return;
    var visiveis = Array.prototype.filter.call(
      root.querySelectorAll("[data-fm-variant-row]"),
      function (r) { return !r.hidden; }
    );
    var marcada = root.querySelector("[data-fm-variant-row].is-selected");
    var atual = marcada ? metragemDe(marcada) : "";

    selMet.innerHTML = "";
    if (!atual) {
      var ph = document.createElement("option");
      ph.value = ""; ph.textContent = "Metragem";
      selMet.appendChild(ph);
    }
    visiveis.forEach(function (r) {
      var m = metragemDe(r);
      if (!m) return;
      var o = document.createElement("option");
      o.value = m;
      o.textContent = m.replace(/\s*metros?/i, "m");
      if (r.getAttribute("data-available") !== "true") o.disabled = true;
      if (m === atual) o.selected = true;
      selMet.appendChild(o);
    });
    selMet.disabled = visiveis.length === 0;
  }

  function sincronizarBarra() {
    if (selBit && selPrincipal) selBit.value = selPrincipal.value || "";
    preencherMetragens();
    atualizarPreco();
  }

  if (selBit && selPrincipal) {
    selBit.addEventListener("change", function () {
      selPrincipal.value = selBit.value;
      selPrincipal.dispatchEvent(new Event("change", { bubbles: true }));
      setTimeout(sincronizarBarra, 40);
    });
  }

  if (selMet) {
    selMet.addEventListener("change", function () {
      var alvo = selMet.value;
      if (!alvo) return;
      var linha = Array.prototype.filter.call(
        root.querySelectorAll("[data-fm-variant-row]"),
        function (r) { return !r.hidden && metragemDe(r) === alvo; }
      )[0];
      if (linha) linha.click();
      setTimeout(sincronizarBarra, 40);
    });
  }

  /* So aparece quando os botoes ja PASSARAM pra cima.
     A primeira versao so olhava "os botoes nao estao visiveis", e no celular
     eles nascem abaixo da dobra — a barra aparecia sozinha no topo da pagina,
     antes do cliente rolar. Por isso a checagem de bottom < 0. */
  function decidir(rect) {
    mostrar(rect.bottom < 0);
  }

  if ("IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { decidir(e.boundingClientRect); });
    }, { threshold: 0 }).observe(acoes);
  }
  /* o observador so dispara quando cruza a borda; este scroll cobre o resto
     (inclusive a carga inicial e navegadores sem IntersectionObserver) */
  var GEN_BARRA = window.__fmPdpGen;
  var aoRolar = function () {
    /* execucao antiga nao mexe mais no body: senao duas barras disputam
       a classe fm-sticky-on e ela pisca */
    if (GEN_BARRA !== window.__fmPdpGen) return;
    decidir(acoes.getBoundingClientRect());
  };
  window.addEventListener("scroll", aoRolar, { passive: true });
  window.addEventListener("resize", aoRolar, { passive: true });
  aoRolar();

  if (btn) {
    btn.addEventListener("click", function () {
      real.click();
    });
  }

  root.addEventListener("click", function () { setTimeout(sincronizarBarra, 60); });
  if (selPrincipal) selPrincipal.addEventListener("change", function () { setTimeout(sincronizarBarra, 60); });
  sincronizarBarra();
})();

/* =========================================================
   CAMUFLAGEM — leva e retoma a escolha entre os dois produtos
   Amazonica e Oceanica sao produtos diferentes, entao trocar de
   camuflagem e trocar de pagina. Pra escolha do cliente nao se
   perder no caminho, bitola e metragem viajam na URL e sao
   reaplicadas do outro lado pelos MESMOS caminhos que um clique
   usaria (select + change, clique na caixa) — nada de escrever
   direto no campo da variante.
   ========================================================= */
(function () {
  var root = document.querySelector("[data-fm-v2-pdp]");
  if (!root) return;

  var sel = root.querySelector("[data-fm-diameter]");
  var link = root.querySelector("[data-fm-camu-link]");

  function metragemDe(r) {
    return (r.getAttribute("data-option2") || r.getAttribute("data-option1") || "").trim();
  }

  /* ---- saindo: escreve a escolha atual no link ---- */
  function atualizarLink() {
    if (!link) return;
    var base = link.getAttribute("data-fm-camu-base") || link.getAttribute("href");
    var q = [];
    if (sel && sel.value) q.push("fm_bitola=" + encodeURIComponent(sel.value));
    var marcada = root.querySelector("[data-fm-variant-row].is-selected");
    if (marcada) q.push("fm_met=" + encodeURIComponent(metragemDe(marcada)));
    link.setAttribute("href", q.length ? base + "?" + q.join("&") : base);
  }

  if (link) {
    root.addEventListener("click", function () { setTimeout(atualizarLink, 60); });
    if (sel) sel.addEventListener("change", function () { setTimeout(atualizarLink, 60); });
    atualizarLink();
  }

  /* ---- troca SEM sair da pagina ----
     Busca so a secao do produto irmao (Section Rendering API), troca o
     HTML no lugar e reinjeta este script — o que reinicia galeria,
     seletores, cascata e barra fixa ja apontando pros elementos novos.
     Bitolas, fotos, precos e SKU vem prontos do servidor; nada e
     remontado no braco aqui, entao nao tem como a tela discordar do
     que vai pro carrinho.
     Qualquer falha (rede, secao vazia, navegador velho) cai na
     navegacao normal: o cliente nunca fica preso. */
  /* NAO da pra usar a Section Rendering API aqui: em template JSON o
     section.id vira "template--<id do template>__main", e esse numero e
     DIFERENTE em cada template. Pedir a secao da Oceanica usando o id da
     Amazonica devolve 404. Entao buscamos a pagina inteira do irmao e
     recortamos o bloco da PDP — funciona sem depender de id nenhum. */

  function criarCarga() {
    var d = document.createElement("div");
    d.className = "fm-camu-carga";
    d.innerHTML = '<span class="fm-camu-carga__giro" aria-hidden="true"></span>';
    d.setAttribute("role", "status");
    d.setAttribute("aria-live", "polite");
    d.setAttribute("aria-label", "Trocando a camuflagem");
    document.body.appendChild(d);
    return d;
  }

  /* o bloco da PDP e o ancestral <section id="shopify-section-..."> do root */
  function blocoDaPdp(doc) {
    var r = doc.querySelector("[data-fm-v2-pdp]");
    if (!r) return null;
    var n = r;
    while (n && n.parentNode && n.parentNode !== doc.body) {
      if (n.id && n.id.indexOf("shopify-section-") === 0) return n;
      n = n.parentNode;
    }
    return r.closest ? r.closest('[id^="shopify-section-"]') : null;
  }

  function trocarNoLugar(url) {
    var alvo = blocoDaPdp(document);
    if (!alvo) { window.location.href = url; return; }

    var topo = window.pageYOffset;
    var carga = criarCarga();

    fetch(url, { credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error("http " + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var nova = blocoDaPdp(doc);
        /* se nao veio uma PDP de verdade, nao troca nada pela metade */
        if (!nova) throw new Error("sem pdp na resposta");

        window.history.pushState({}, "", url);
        var titulo = doc.querySelector("title");
        if (titulo) document.title = titulo.textContent;

        alvo.parentNode.replaceChild(document.importNode(nova, true), alvo);
        window.scrollTo(0, topo);

        var s = document.createElement("script");
        s.src = window.__fmPdpSrc;
        s.onload = function () { setTimeout(function () { carga.remove(); }, 80); };
        s.onerror = function () { window.location.href = url; };
        document.body.appendChild(s);
      })
      .catch(function () { carga.remove(); window.location.href = url; });
  }

  if (link && window.fetch && window.history && window.history.pushState) {
    link.addEventListener("click", function (e) {
      var url = link.getAttribute("href");
      if (!url) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return; // abrir em nova aba continua funcionando
      e.preventDefault();
      trocarNoLugar(url);
    });
  }

  /* ---- chegando de outra camuflagem: reaplica o que veio na URL ---- */
  function param(nome) {
    var m = new RegExp("[?&]" + nome + "=([^&]*)").exec(window.location.search);
    return m ? decodeURIComponent(m[1].replace(/\+/g, " ")) : "";
  }

  var bitolaURL = param("fm_bitola");
  var metURL = param("fm_met");
  if (!bitolaURL && !metURL) return;

  /* casa pelo trecho do mm ("0.28mm"): a libragem muda entre 4x e 8x,
     entao comparar o valor inteiro nao acharia o equivalente. */
  function acharBitola(alvo) {
    if (!sel) return "";
    var mm = (alvo.split("(")[0] || "").replace(/\s+/g, "");
    for (var i = 0; i < sel.options.length; i++) {
      var v = sel.options[i].value;
      if (v && mm && v.replace(/\s+/g, "").indexOf(mm) === 0) return v;
    }
    return "";
  }

  setTimeout(function () {
    if (bitolaURL && sel) {
      var achou = acharBitola(bitolaURL);

      /* A bitola equivalente pode NAO EXISTIR nesta camuflagem, ou existir
         esgotada. Insistir nela deixava o cliente numa tela morta: metragens
         todas riscadas, sem nada clicavel. Entao cai na mesma cascata do
         botao de compra (preferidas -> primeira disponivel). */
      if (!achou || (root.fmBitolaTemEstoque && !root.fmBitolaTemEstoque(achou))) {
        achou = root.fmEscolherBitola ? root.fmEscolherBitola() : "";
      }

      if (achou) {
        sel.value = achou;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    if (metURL) {
      /* so reaplica a metragem se ela existir E estiver disponivel nesta
         bitola; senao deixa o padrao (300m) que o filtro ja marcou */
      var linha = Array.prototype.filter.call(
        root.querySelectorAll("[data-fm-variant-row]"),
        function (r) {
          return !r.hidden &&
                 r.getAttribute("data-available") === "true" &&
                 metragemDe(r) === metURL;
        }
      )[0];
      if (linha) linha.click();
    }
  }, 120);
})();

/* =========================================================
   RESUMO DA SELECAO + GALERIA POR CAMUFLAGEM (30/09)

   Duas coisas que andam juntas na pagina de camuflagem-variante:

   1. O resumo le a LINHA DE METRAGEM MARCADA, nao um calculo
      proprio. Se ele recalculasse preco por conta, um dia a tela
      mostraria um valor e o carrinho outro — foi assim que o kit
      quebrou em setembro.

   2. A galeria filtra as miniaturas pelo data-camu. Foto sem marca
      aparece em qualquer camuflagem (padrao seguro): produto sem a
      3a opcao continua com a galeria inteira, como sempre foi.
   ========================================================= */
(function () {
  var root = document.querySelector("[data-fm-v2-pdp]");
  if (!root) return;

  var GEN = window.__fmPdpGen;
  var resumo = root.querySelector("[data-fm-resumo]");
  var thumbs = root.querySelectorAll("[data-fm-thumb]");
  var slides = root.querySelectorAll("[data-fm-slide]");
  var selBitola = root.querySelector("[data-fm-diameter]");
  if (!resumo && !thumbs.length) return;

  function camuAtual() {
    var b = root.querySelector("[data-fm-camu-var].is-selected");
    return b ? b.getAttribute("data-value") : "";
  }

  function soNum(t) {
    var n = String(t || "").replace(/[^\d,.-]/g, "").replace(/\./g, "").replace(",", ".");
    return parseFloat(n) || 0;
  }

  /* ---- galeria: mostra so as fotos da camuflagem escolhida ---- */
  /* Qual camuflagem o filtro ja aplicou. Sem isso, filtrarGaleria roda a
   * CADA clique na PDP (vem de root.addEventListener("click")) e mandava a
   * galeria de volta pra primeira foto — inclusive quando o clique era na
   * propria seta. O sintoma era a seta andar 53px e voltar.
   * Agora o filtro so mexe na galeria quando a camuflagem realmente muda. */
  var camuAplicada = null;

  function filtrarGaleria() {
    if (!thumbs.length) return;
    var camu = camuAtual();
    if (camu === camuAplicada) return;
    camuAplicada = camu;
    var sobrou = 0;

    /* esconde MINIATURA E SLIDE pelo mesmo criterio. Filtrar so um dos dois
       deixaria o trilho mostrando foto da camuflagem que nao esta escolhida
       — sem erro nenhum no console, o pior tipo de falha. */
    function aplicar(lista) {
      Array.prototype.forEach.call(lista, function (el) {
        var c = el.getAttribute("data-camu");
        var mostra = !c || !camu || c === camu;
        el.hidden = !mostra;
        if (mostra) sobrou++;
      });
    }
    aplicar(thumbs);
    aplicar(slides);
    if (!sobrou) return;

    /* a contagem de fotos visiveis mudou: refaz as bolinhas e volta pra
       primeira foto da camuflagem escolhida */
    var g = root.fmGaleria;
    if (g) {
      g.montarBolas();
      g.irPara(0, false);
      g.sincronizar();
    }
  }

  /* ---- resumo ---- */
  function atualizarResumo() {
    if (!resumo) return;

    var elLabel = resumo.querySelector("[data-fm-resumo-label]");
    var elOff = resumo.querySelector("[data-fm-resumo-off]");
    var elPreco = resumo.querySelector("[data-fm-resumo-preco]");
    var elWas = resumo.querySelector("[data-fm-resumo-was]");
    var elSel = resumo.querySelector("[data-fm-resumo-sel]");

    var linha = root.querySelector("[data-fm-variant-row].is-selected");
    var bitola = selBitola ? selBitola.value : "";
    var camu = camuAtual();

    var partes = [];
    if (camu) partes.push(camu);

    if (!linha) {
      /* nada escolhido: menor preco, dito como "a partir de" */
      var min = resumo.getAttribute("data-fm-preco-min") || "";
      if (!min) { resumo.hidden = true; return; }
      resumo.hidden = false;
      if (elLabel) elLabel.textContent = "A partir de";
      if (elPreco) elPreco.textContent = min;
      if (elWas) elWas.textContent = "";
      if (elOff) elOff.textContent = "";
      partes.push('<span class="fm-resumo__falta">escolha a metragem</span>');
      if (elSel) elSel.innerHTML = partes.join(" · ");
      return;
    }

    var pEl = linha.querySelector(".fm-v3-box__price");
    var wEl = linha.querySelector(".fm-v3-box__was");
    var metros = (linha.getAttribute("data-option2") || linha.getAttribute("data-option1") || "").trim();

    resumo.hidden = false;
    if (elLabel) elLabel.textContent = bitola ? "Você está levando" : "A partir de";
    if (elPreco) elPreco.textContent = pEl ? pEl.textContent.trim() : "";
    if (elWas) elWas.textContent = wEl ? wEl.textContent.trim() : "";

    if (elOff) {
      var de = wEl ? soNum(wEl.textContent) : 0;
      var por = pEl ? soNum(pEl.textContent) : 0;
      elOff.textContent = (de > por && de > 0) ? Math.floor((de - por) / de * 100) + "% de desconto" : "";
    }

    if (metros) partes.push(metros);
    if (bitola) {
      partes.push(bitola);
    } else {
      partes.push('<span class="fm-resumo__falta">falta escolher a bitola</span>');
    }
    if (elSel) elSel.innerHTML = partes.join(" · ");
  }

  function atualizar() {
    if (GEN !== window.__fmPdpGen) return;
    filtrarGaleria();
    atualizarResumo();
  }

  root.addEventListener("click", function () { setTimeout(atualizar, 60); });
  if (selBitola) selBitola.addEventListener("change", function () { setTimeout(atualizar, 60); });
  atualizar();
})();
